/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { Combobox, Dialog, FilledButton } from '@neo4j-ndl/react';
import { useState } from 'react';

const options = [
  { label: 'Neo4j', value: 'neo4j' },
  { label: 'Aura', value: 'aura' },
  { label: 'Bloom', value: 'bloom' },
  { label: 'Data Importer', value: 'data-importer' },
  { label: 'GraphQL Library', value: 'graphql-library' },
  { label: 'Cypher', value: 'cypher' },
];

const Component = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <FilledButton onClick={() => setIsOpen(true)}>Open dialog</FilledButton>
      <Dialog isOpen={isOpen} onClose={() => setIsOpen(false)} size="medium">
        <Dialog.Header>Combobox in a dialog</Dialog.Header>
        <Dialog.Description>
          The panel automatically uses fixed positioning and stays inside the
          dialog rather than being portaled.
        </Dialog.Description>
        <Dialog.Content>
          <Combobox
            label="Product"
            helpText="Open the list to inspect clipping and stacking."
            isFluid
            options={options}
            searchPlaceholder="Search products"
          />
        </Dialog.Content>
      </Dialog>
    </>
  );
};

export default Component;
